/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../components/finalForms/FormCreator";

/** Configuration files */
import { GLAccountFormConfig } from "./GLAccount.formfield.config";

/**Wrapped Component */
import Financial from "../../Financial";

/** API calling */
import { useLazyGetAllGLAccountsQuery } from "../../../../app/services/financialsAPI";

/** Utils */
import { SystemOptionMappings } from "../../../../utils/ENUMS/SystemOptionMappings";


const GLAccounts = () => {
  const gLAccountRef = useRef();
  const [gLAccountBasicForm, setgLAccountBasicForm] = useState(GLAccountFormConfig);

  const [getAllGLAccounts, {
    isFetching: isAllGLAccountsFetching,
    isSuccess: isAllGLAccountsFetched,
    data: AllGLAccountsData
  }] = useLazyGetAllGLAccountsQuery();

  useEffect(() => {
    getAllGLAccounts();
  }, [])

  useEffect(() => {
    if (!isAllGLAccountsFetching && isAllGLAccountsFetched && AllGLAccountsData) {
      const form = { ...GLAccountFormConfig.initialState }
      SystemOptionMappings.forEach(({ field, key }) => {
        const matchItem = AllGLAccountsData.find((opt) => opt.lSystemOptionsKey === key);
        if (matchItem && field in form) {
          form[field] = matchItem.mValueText ?? "";
        }
      });
      setgLAccountBasicForm((prev) => ({
        ...prev,
        initialState: form
      }));
    }
  }, [isAllGLAccountsFetching, isAllGLAccountsFetched, AllGLAccountsData])



  return (
      <div className="gl-accounts-sec pb-2 m-0 row">
        <FormCreator
          config={gLAccountBasicForm}
          ref={gLAccountRef}
          key={false}
        />
      </div>
  );
};

export default Financial(GLAccounts);
